import React, { useContext } from 'react'
import { LanguageContext } from '../../contexts/language'
import './Impressum.css'

const Impressum = () => {
  const { language } = useContext(LanguageContext)
  const impressumText = {
    de: (
      <section className="impressum">
        <h1>Impressum</h1>
        <h2>Angaben gemäß § 5 TMG</h2>
        <p>
          Mehmet Karaca<br />
          Musterstraße 1<br />
          12345 Musterstadt<br />
          Deutschland
        </p>
        <h2>Kontakt</h2>
        <p>
          Telefon: 01234 / 567890<br />
          E-Mail: <a href="mailto:Karaca.Mehmet@outlook.de">Karaca.Mehmet@outlook.de</a>
        </p>
        <h2>Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</h2>
        <p>
          Mehmet Karaca<br />
          Musterstraße 1<br />
          12345 Musterstadt<br />
          Deutschland
        </p>
        <p className="impressum__hint">
          Dieses Impressum gilt auch für die Social-Media-Profile von Mehmet Karaca.<br />
          <strong>Hinweis:</strong> Dies ist ein Muster-Impressum. Bitte passe die Angaben an deine tatsächlichen Kontaktdaten und rechtlichen Anforderungen an!
        </p>
      </section>
    ),
    en: (
      <section className="impressum">
        <h1>Imprint</h1>
        <h2>Information according to § 5 TMG</h2>
        <p>
          Mehmet Karaca<br />
          Musterstraße 1<br />
          12345 Musterstadt<br />
          Germany
        </p>
        <h2>Contact</h2>
        <p>
          Phone: 01234 / 567890<br />
          Email: <a href="mailto:Karaca.Mehmet@outlook.de">Karaca.Mehmet@outlook.de</a>
        </p>
        <h2>Responsible for the content according to § 55 Abs. 2 RStV</h2>
        <p>
          Mehmet Karaca<br />
          Musterstraße 1<br />
          12345 Musterstadt<br />
          Germany
        </p>
        <p className="impressum__hint">
          This imprint also applies to the social media profiles of Mehmet Karaca.<br />
          <strong>Note:</strong> This is a sample imprint. Please adapt the information to your actual contact details and legal requirements!
        </p>
      </section>
    )
  }
  return impressumText[language]
}

export default Impressum
